<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row no-gutters>
            <v-col cols="3">Filtri</v-col>
            <v-col cols="8" class="text--secondary">
              <!-- <v-fade-transition leave-absolute> -->
                <span  v-if="open" key="0">Imposta i filtri di visualizzazione</span>
                <span v-else key="1">
                  <v-chip v-if="filtro.codice" class="mr-1">{{ filtro.codice }}</v-chip>
                  <v-chip v-if="filtro.descrizione" class="mr-1">{{ filtro.descrizione }}</v-chip>
                  <v-chip v-if="filtro.testo" class="mr-1">{{ filtro.testo }}</v-chip>
                  <v-chip v-if="filtro.barcode" class="mr-1">{{ filtro.barcode }}</v-chip>
                  <v-chip class="mr-1" v-for="x in unionFiltri" :key="x">{{ x }}</v-chip>
                </span>
              <!-- </v-fade-transition> -->
            </v-col>
            <v-col cols="1" v-if="open"><v-btn @click.stop="onFiltra">Ricerca</v-btn></v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row align="center" justify="space-around" dense>
          <v-col md="4">
            <v-text-field v-model="filtro.codice" dense outlined label="Codice" clearable @keydown.enter="onFiltra" hide-details  @click:clear="onClear"></v-text-field>
          </v-col>
          <v-col md="4">
            <v-text-field v-model="filtro.descrizione" dense outlined label="Descrizione (comincia per)" clearable @keydown.enter="onFiltra" hide-details @click:clear="onClear"></v-text-field>
          </v-col>
          <v-col md="4">
            <v-text-field v-model="filtro.testo" dense outlined label="Testo contenuto" clearable @keydown.enter="onFiltra" hide-details @click:clear="onClear"></v-text-field>
          </v-col>          
        </v-row>
        <v-row align="center" justify="space-around" dense>
          <v-col md="4">
            <v-autocomplete v-model="filtro.marchio" :items="marchi" dense chips small-chips flat outlined multiple label="Marchio" item-text="descrizione" item-value="codice" clearable hide-details @click:clear="onClear"></v-autocomplete>
          </v-col>
          <v-col md="4">
            <v-text-field v-model="filtro.barcode" dense outlined label="Barcode" clearable @keydown.enter="onFiltra" hide-details @click:clear="onClear"></v-text-field>
          </v-col>
          <v-col md="2">
            <v-select v-model="filtro.tipoIntervalloPrezzo" :items="tipiFiltroPrezzo" dense flat outlined label="Intervallo prezzi" item-text="descrizione" item-value="codice" clearable hide-details @click:clear="onClear"></v-select>
          </v-col>             
          <v-col md="2">
            <v-text-field v-model="filtro.prezzo" dense outlined label="Prezzo vendita" clearable @keydown.enter="onFiltra" hide-details @click:clear="onClear"></v-text-field>
          </v-col>
        </v-row>        
        <v-row justify="space-around" dense>
          <v-col md="6">
            <v-autocomplete v-model="filtro.categoria1" :items="categoria1" dense chips small-chips flat outlined multiple label="Categoria 1" item-text="descrizione" item-value="codice" clearable hide-details @click:clear="onClear"></v-autocomplete>
          </v-col>
          <v-col md="6">
            <v-autocomplete v-model="filtro.categoria2" :items="categoria2" dense chips small-chips flat outlined multiple label="Categoria 2" item-text="descrizione" item-value="codice" clearable hide-details @click:clear="onClear"></v-autocomplete>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  import configurazioni from '@/services/configurazioniService.js'
  import { dynamicSortMultiple } from '@/components/helpers.js'
  export default {
    props: {
      usaTagliaColore: Boolean
    },
    data: () => ({
      marchi: [],
      variante1: [],
      variante2: [],
      stagioni: [],
      categoria1: [],
      categoria2: [],
      tipiFiltroPrezzo: [{ codice: '$lte', descrizione: 'Minore' }, { codice: '$gte', descrizione: 'Maggiore' }, { codice: '$eq', descrizione: 'Uguale' }],
      filtro: {
        testo: '',
        marchio: [],
        variante1: [],
        variante2: [],
        stagione: [],
        categoria1: [],
        categoria2: []   
      }
    }),
    async mounted() {
      // passare le configurazioni da DB
      this.marchi = (await this.getValues('prodotti_categorie.marchi')).sort(dynamicSortMultiple('descrizione'))
/*       this.variante1 = (await this.getValues('prodotti_varianti.varianti.variante1')).sort(dynamicSortMultiple('descrizione'))
      this.variante2 = (await this.getValues('prodotti_varianti.varianti.variante2')).sort(dynamicSortMultiple('descrizione'))
      let stagioni = (await this.getValues('prodotti_categorie.stagioni')).sort(dynamicSortMultiple('descrizione'))
      if (!stagioni || stagioni.length === 0) {
        stagioni = (await this.getValues('benetton_categorie.stagioni')).sort(dynamicSortMultiple('descrizione'))
      }
      this.stagioni = stagioni */
      this.categoria1 = (await this.getValues('prodotti_categorie.categorie.categoria1')).sort(dynamicSortMultiple('descrizione'))
      this.categoria2 = (await this.getValues('prodotti_categorie.categorie.categoria2')).sort(dynamicSortMultiple('descrizione'))
    },
    computed: {
      unionFiltri() {
        const cat1 = this.categoria1.filter(x => this.filtro.categoria1.includes(x.codice)).map(x => x.descrizione)
        const cat2 = this.categoria2.filter(x => this.filtro.categoria2.includes(x.codice)).map(x => x.descrizione)
        const var1 = this.variante1.filter(x => this.filtro.variante1.includes(x.codice)).map(x => x.descrizione)
        const var2 = this.variante2.filter(x => this.filtro.variante2.includes(x.codice)).map(x => x.descrizione)
        const stag = this.stagioni.filter(x => this.filtro.stagione.includes(x.codice)).map(x => x.descrizione)
        return this.filtro.marchio.concat(cat1).concat(cat2).concat(var1).concat(var2).concat(stag)
      }
    },
    methods: {
      onFiltra() {
        this.$emit('ricerca', this.filtro)
      },
      async onClear() {
        await this.$nextTick()
        this.onFiltra()
      },
      async getValues(source) {
        let elementi = []
        if (typeof source === 'string') {
          const config = source.split('.')
          const configId = config[0]
          const subId = config[1] || '' // TODO verificare
          const sub2 = config[2] || ''
          const sourceArray = await configurazioni.getConfigurazione(configId, subId)
          if (sub2) {
            elementi = sourceArray && sourceArray.length > 0 ? sourceArray.filter(x => x.tipo === sub2).map(x => { return { codice: x.codice, descrizione: x.descrizione } }) : []
          } else {
            elementi = sourceArray && sourceArray.length > 0 ? sourceArray.map(x => { return { codice: x.codice, descrizione: x.descrizione } }) : []
          }
        } else if (Array.isArray(source)) {
          elementi = [...source]
        }
        return elementi
      }
    }
  }
</script>
